import {TemplatingEngine, TaskQueue, View, Aurelia} from "aurelia-framework";

let app: Aurelia, enhanced: boolean;
const enhanceHooks: Function[] = [];
const componentMap: Map<Element, View> = new Map();

export function aureliaEnhance(node: Element, bindingContext: Object = {}) {
  if (componentMap.has(node)) {
    const component = componentMap.get(node);
    component.detached();
    component.unbind();
  }

  const engine: TemplatingEngine = app.container.get(TemplatingEngine);
  const component = engine.enhance({
    element: node,
    bindingContext: bindingContext
  });

  // TODO: check if bind call twice
  // component.bind(bindingContext);
  component.attached();
  componentMap.set(node, component);

  for (let hook of enhanceHooks) {
    const taskQueue: TaskQueue = app.container.get(TaskQueue);
    taskQueue.queueMicroTask(hook);
  }

  enhanced = true;
}

export function preEnhance() {
  enhanced = false;
  enhanceHooks.length = 0;
}

export function afterEnhance(callback: () => {}) {
  if (enhanced) {
    const taskQueue: TaskQueue = app.container.get(TaskQueue);
    taskQueue.queueMicroTask(callback);
  } else {
    enhanceHooks.push(callback);
  }
}

export async function enhance(application: Aurelia) {
  app = application;
  await application.enhance();
  enhanced = true;
}

